import { Link, useNavigate } from "react-router-dom";
import { 
  HiOutlineHome, 
  HiOutlineChatBubbleLeftRight, 
  HiOutlineChatBubbleLeft, 
  HiOutlineChartBar, 
  HiOutlineAcademicCap, 
  HiOutlineBell,
  HiOutlineUser,
  HiChevronLeft,
  HiChevronRight
} from "react-icons/hi2";
import { useSelector } from "react-redux";
import logo from '../assets/logo.png';

const Sidebar = ({ active, setActive, user, isOpen, setIsOpen, isCollapsed, setIsCollapsed }) => {
  const navigate = useNavigate();
  const { theme } = useSelector((state) => state.theme);

  const menu = [
    { id: 1, name: "Dashboard", icon: <HiOutlineHome size={22} />, slug: "dashboard", type: 1 },
    { id: 2, name: "Personal Chat", icon: <HiOutlineChatBubbleLeft size={22} />, slug: "personal-chat", type: 1 },
    { id: 3, name: "Group Chat", icon: <HiOutlineChatBubbleLeftRight size={22} />, slug: "chat", type: 1 },
    { id: 4, name: "Market Data", icon: <HiOutlineChartBar size={22} />, slug: "market-data", type: 1 },
    { id: 5, name: "Courses", icon: <HiOutlineAcademicCap size={22} />, slug: "courses", type: 1 },
    { id: 6, name: "Alerts", icon: <HiOutlineBell size={22} />, slug: "site-alerts", type: 1 },
    { id: 7, name: "Profile", icon: <HiOutlineUser size={22} />, slug: "profile", type: 1 },
  ];

  const handleNavClick = (item) => {
    if (item?.type === 1 || (user?.expired_at && new Date(user?.expired_at) > new Date())) {
      setActive(item?.id);
      navigate(`/${item?.slug}`);
      if (window.innerWidth < 1024) {
        setIsOpen(false);
      }
    } else {
      alert("You are not allowed to access this page. Please contact your administrator.");
    }
  };

  return (
    <>
      {/* Mobile Backdrop */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={() => setIsOpen(false)}
        />
      )}

      <aside 
        className={`fixed inset-y-0 left-0 z-50 transform ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        } lg:translate-x-0 transition-all duration-300 ease-in-out ${
          theme === 'dark' ? 'bg-[#2f3349] text-[#cfd3ec]' : 'bg-white text-gray-700'
        } shadow-xl lg:static lg:inset-auto lg:shadow-none h-full flex flex-col ${
          isCollapsed ? "lg:w-[84px]" : "lg:w-52 w-52"
        }`}
      >
        <div className={`flex items-center h-16 px-6 justify-center relative flex-shrink-0`}>
          <Link to="/" className="flex items-center space-x-3 overflow-hidden">
            <img src={logo} alt="Logo" className="h-8 w-8 min-w-[32px]" />
            {!isCollapsed && (
              <span className={`font-bold text-xl tracking-tight transition-opacity duration-300 ${theme === 'dark' ? 'text-white' : 'text-indigo-600'}`}>
                IAATO
              </span>
            )}
          </Link>
          
          <button 
            onClick={() => setIsOpen(false)}
            className="lg:hidden absolute right-4 p-2 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>

          {/* Collapse toggle for desktop */}
          <button 
            onClick={() => setIsCollapsed(!isCollapsed)}
            className={`hidden lg:flex absolute -right-3 top-6 items-center justify-center p-1 rounded-full bg-indigo-600 text-white hover:bg-indigo-700 shadow-md z-50 transition-transform duration-300`}
          >
            {isCollapsed ? <HiChevronRight size={18} /> : <HiChevronLeft size={18} />}
          </button>
        </div>

        <div className="flex-1 overflow-y-auto">
          <nav className={`mt-4 space-y-1 ${isCollapsed ? 'px-3' : 'px-4'}`}>
            {menu.map((item) => {
              if (item?.type === 2 && (!user?.expired_at || new Date(user?.expired_at) < new Date())) {
                return null;
              }
              const isActive = item.id === active;
              return (
                <div
                  key={item.id}
                  onClick={() => handleNavClick(item)}
                  title={isCollapsed ? item.name : ""}
                  className={`flex items-center rounded-lg cursor-pointer transition-all duration-200 ${
                    isCollapsed ? 'px-3 py-2.5 justify-center' : 'px-4 py-2.5'
                  } ${
                    isActive 
                      ? "bg-indigo-600 text-white shadow-md" 
                      : theme === 'dark'
                        ? "hover:bg-gray-700/50"
                        : "hover:bg-indigo-50 hover:text-indigo-600"
                  }`}
                >
                  <span className={`${isActive ? "text-white" : "text-gray-400"} transition-colors duration-200`}>
                    {item.icon}
                  </span>
                  {!isCollapsed && (
                    <span className="ml-3 font-medium transition-opacity duration-300 whitespace-nowrap overflow-hidden">
                      {item.name}
                    </span>
                  )}
                </div>
              );
            })}
          </nav>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
